'use client';

import { PageNavigation } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

import { CartIconLink } from '../../_components/CartIconLink';

export const GiftsPageNavigation = () => {
  const router = useCustomRouter();

  return (
    <PageNavigation
      donationHomeButton
      isNotUsedHomeButton
      searchForm
      searchFormClassName="cursor-pointer"
      onSearchFormClick={() => {
        router.push(DONATION_ROUTES.GIFTS_SEARCH.pathname);
      }}
    >
      <CartIconLink className="ml-10 self-center" />
    </PageNavigation>
  );
};
